<template>
  <div
    class="w-full pt-[78px] desktop:pt-[94px] tablet-h:pt-10 tablet-v:pt-[111px] text-[22px] leading-[28px] text-gray-800 font-primary font-semibold text-center flex flex-col items-center px-6"
  >
    <div class="w-full max-w-[450px] flex flex-col flex-grow">
      <div class="max-w-[350px] tablet-v:w-full mx-auto mb-5">
        {{ question }}
      </div>

      <div class="mt-auto w-full">
        <div class="flex flex-col gap-y-[9px] mb-[30px]">
          <SelectOption v-model="answer" icon="👍" value="Yes">
            Yes
          </SelectOption>
          <SelectOption v-model="answer" icon="🤞" value="No">
            No, I'll risk it
          </SelectOption>
        </div>

        <UiButton
          class="w-full"
          :disabled="!answer"
          primary
          large
          @click="handleClick"
        >
          Next
        </UiButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import SelectOption from '@/shared/components/SelectOption.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { computed } from 'vue'
import { OnboardingStep, useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const question =
  'Do you now, or in the future, need proof of ownership of your work to support you in court?'

const answer = computed({
  get() {
    return (onboardingStore.state[OnboardingStep.Seven] || '') as string
  },
  set(value: string) {
    onboardingStore.state[OnboardingStep.Seven] = value
  },
})

const handleClick = () => {
  completeStep({
    step: 7,
    question,
    answers: [answer.value],
  })

  onboardingStore.goToNextStep({
    question,
    answers: [answer.value],
  })
}
</script>
